import * as React from 'react';
import { styled } from '@glitz/react';
import { bareListDecorator } from 'webapp/decorators/list';
import { createTransitionDecorator } from '@avensia/excite-ui';
import { scrollbarDecorator } from 'webapp/decorators/scrollbar';
import { MenuItem } from './MenuItem';
import { LevelHeading } from './LevelHeading';
import { LEVEL_WIDTH } from 'webapp/shell/main-menu/helpers';

import type { JSX } from "react";

type PropType = {
  setActiveLevel?: (level: number) => void;
  level: NordicNest.Api.MenuItemApiModel;
  selectedLevel?: NordicNest.Api.MenuItemApiModel;
  setSelectedLevel?: (level: NordicNest.Api.MenuItemApiModel) => void;
  menu_category: string;
  openLevel: boolean;
};

export const NextLevel = ({
  setActiveLevel,
  level,
  selectedLevel,
  setSelectedLevel,
  menu_category,
  openLevel,
}: PropType): JSX.Element => {
  return (
    <Base css={openLevel && openLevelDecorator}>
      {openLevel && (
        <>
          <LevelHeading level={level} menu_category={menu_category} />
          <List>
            {level.childPages?.map((child, i) => (
              <MenuItem
                key={child.link?.to + i}
                level={child}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                setActiveLevel={setActiveLevel}
                menu_type="side"
                menu_category={menu_category}
              />
            ))}
          </List>
        </>
      )}
    </Base>
  );
};

const Level = styled.div(scrollbarDecorator, {
  minWidth: LEVEL_WIDTH,
  margin: { y: t => t.sharedSpacing.xxl },
  overflowY: 'auto',
  overflowX: 'hidden',
});

const openLevelDecorator = styled({
  width: LEVEL_WIDTH,
  border: { left: { width: 1 } },
});

const Base = styled(Level, createTransitionDecorator({ property: ['width', 'border', 'padding'], duration: 300 }), {
  border: { left: { width: 0, style: 'solid', color: t => t.header?.menuHightlightColor } },
  width: 0,
  padding: { xy: 0 },
  minWidth: 'auto',
});

const List = styled.ul(bareListDecorator, {
  display: 'flex',
  flexDirection: 'column',
  breakInside: 'avoid',
});
